import { useNavigate } from 'react-router-dom'

import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import type { Adapter } from 'modules/core/lib/mobx-rest/types'
import app from 'modules/core/store/models/app'

import { useEmployeesImporter } from 'modules/employees/lib/employeesImporterContext'
import { TargetBalance } from 'modules/timeoff/lib/enums'

const IMPORTS_PATH = '/onboarding_importer/imports_timeoff'
interface Props {
  api: Adapter
}

const useProcessFile = ({ api }: Props) => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const importer = useEmployeesImporter()
  const { running, performAction: onSubmit } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      const file = importer.files[0]

      if (!file) return

      try {
        const payload = await api.post(IMPORTS_PATH, {
          file,
          target_balance: importer.targetBalance,
          skip_notifications: importer.skipNotifications,
        })

        const { token, employees } = payload

        importer.setEmployees({ employees })
        importer.setToken(token)
        importer.setFiles([])
        importer.setTargetBalance(TargetBalance.Available)
        importer.setSkipNotifications(false)
        closePortal()

        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })

        navigate(navigation.employees.import.fullPath())
      } catch (error: unknown) {
        let errorMsg = ''
        if (
          error &&
          typeof error === 'object' &&
          'payload' in error &&
          error.payload &&
          typeof error.payload === 'object' &&
          'errors' in error.payload &&
          Array.isArray(error.payload.errors) &&
          error.payload.errors.length > 0
        ) {
          errorMsg = error.payload.errors[0]
        }
        app.setFlash({
          type: 'wrong',
          message: i18n.t('errors.failed_import', { error: errorMsg }),
        })
      }
    },
    {
      successFlash: false,
    }
  )

  return {
    running,
    onSubmit,
  }
}

export default useProcessFile
